<template>
  <div>
    <app-general-accounting-statement
      apiEndPoint="/accounting/cashier-box/cashierBoxStatement/"
    ></app-general-accounting-statement>
  </div>
</template>

<script>
import generalAccountingStatement from "./generalAccountingStatement.vue";
export default {
  components: {
    appGeneralAccountingStatement: generalAccountingStatement,
  },
};
</script>

<style>
</style>
